import React from "react";
import Notification from "~/components/entities/notification/Notification";
import Conversations from "~/components/Processes/conversations/Conversations";
import useRequestDashboard from "../actions/useRequestDashboard";

const RequestConversation = ({ requestType }) => {
  const {
    states,
    formatDate,
    setNotificationMessage,
    fetchCoversations,
    setdeleteMessageLoading,
    deleteConversation,
    setDeleteModal,
    setSelectedMessage,
    resetPaginationState,
  } = useRequestDashboard("coversation", requestType);

  // Simple wrapper - just call fetchCoversations regardless of type
  const fetchMessageshandler = async () => {
    await fetchCoversations(requestType);
  };

  const deleteConversationHandler = async (id) => {
    await deleteConversation(id);
  };

  return (
    <>
      <Notification
        message={states?.notificationMessage}
        setMessage={setNotificationMessage}
      />
      <Conversations
        messages={states?.messages}
        fetchMessages={fetchMessageshandler}
        isMessageLoading={states?.messageLoading}
        formatDate={formatDate}
        isPublic={false}
        deleteConversation={deleteConversationHandler}
        isDeleteLoading={states?.deletemessageLoading}
        setDeleteLoading={setdeleteMessageLoading}
        deleteModal={states?.deleteModal}
        setDeleteModal={setDeleteModal}
        selectedMessage={states?.selectedMessage}
        setSelectedMessage={setSelectedMessage}
        entitydata={states?.requestdata?.entityData}
        relatedType="REQUEST"
        serviceData={states?.requestdata?.serviceData}
        requestdata={states?.requestdata}
        requestType={requestType}
      />
    </>
  );
};

export default RequestConversation;
